import React from "react";
import { object, bool } from "prop-types";
import get from "lodash/get";

import CollectionHeading from "../../atoms/collection-heading";
import { getStoryFromCollection } from "../../../helper/utils";
import TitleAboveHeroImage from "../../molecules/titleAboveHeroImage";
import SmallStoryCardWithTopBorder from "../../molecules/smallStoryCardWithTopBorder";

import "./common-row.m.css";

const CommonRow = ({ collection = {}, showHeadingName = true }) => {
  const stories = getStoryFromCollection(collection);

  if (!stories.length) {
    return null;
  }

  const firstStory = stories[0];
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const containerName = `${showCollectionName ? "" : "no-collection-name"}`;

  return (
    <div styleName={containerName}>
      {showHeadingName && showCollectionName && <CollectionHeading collection={collection} />}
      <TitleAboveHeroImage story={firstStory} width={400} />
      {stories.length > 1 &&
        stories.slice(1, 4).map(story => <SmallStoryCardWithTopBorder story={story} key={story.id} width={150} />)}
    </div>
  );
};

CommonRow.propTypes = {
  collection: object,
  showHeadingName: bool
};

export default CommonRow;
